import React, { useState } from 'react';
import { Box, TextField, InputAdornment, Typography, Divider } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PropTypes from 'prop-types';
import DataSetSection from './DataSetSection';
import IntegrationSection from './IntegrationSection';
import FunctionsSection from './FunctionsSection';
import StreamingFunctionSection from './StreamingFunctionSection';

export default function Sidebar({ activeTab = 0 }) {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <Box
      sx={{
        width: 265,
        bgcolor: 'white',
        boxShadow: '0px 4px 10px 0px rgba(0,0,0,0.05)',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        maxHeight: '100vh',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Main Content */}
      <Box sx={{ px: 3, flex: 1, overflowY: 'auto', pb: 3, pt: 16 }}>
        {activeTab === 0 && (
          <>
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
                pb: 2,
                backgroundColor: 'white',
              }}
            >
              <TextField
                placeholder="Search"
                size="small"
                fullWidth
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    bgcolor: 'white',
                    borderRadius: '4px',
                    boxShadow: '0px 4px 10px 0px #0000000D',
                    height: 32,
                    '& fieldset': {
                      border: '1px solid #E6E6E6',
                    },
                    '& input': {
                      fontFamily: 'Open Sans, sans-serif',
                      fontSize: '0.875rem',
                      color: '#4F4F4F',
                      padding: '0 12px',
                    }
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#7A7A7A', fontSize: 20 }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            <Typography 
              sx={{ 
                fontFamily: 'IBM Plex Sans, sans-serif',
                fontWeight: 500,
                fontSize: '1rem',
                color: '#525252',
                mb: 2.125
              }}
            >
              Select Data Set
            </Typography>

            <DataSetSection />

            <Divider sx={{ my: 2.125, borderColor: '#929292' }} />

            <IntegrationSection />

            <Divider sx={{ my: 2.125, borderColor: '#929292' }} />

            <StreamingFunctionSection />
          </>
        )}

        {activeTab === 1 && (
          <FunctionsSection />
        )}
      </Box>
    </Box>
  );
}

Sidebar.propTypes = {
  activeTab: PropTypes.number,
};
